import React, {Fragment} from 'react';
import MemberCard from "../components/MemberCard";

const initialState = {}

class MapView extends React.Component {

    static defaultProps = {
        withLocation: false,
        categories: [],
        members: [],
        onClick: () => {}
    }

    constructor(props) {
        super(props);
        this.state = initialState;
    }

    render() {

        const {
            categories,
            members,
            onClick,
            withLocation
        } = this.props;

        return (
            <Fragment>
                <div className="container-fluid">
                    <div className="row">
                {
                    members.map((member, index) => {
                        return (
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                            <MemberCard
                                key={'membercard_' + member.member_id}
                                withLocation={withLocation}
                                categories={categories}
                                member={member}
                                onClick={() => {
                                    onClick(member, index)
                                }}
                            />
                            </div>
                        )
                    })
                }
                    </div>
                </div>
            </Fragment>
        )
    }

}

export default MapView;